import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageHeader } from '@/components/common/PageHeader';
import { SectionTitle } from '@/components/common/SectionTitle';
import { Card } from '@/components/ui/card';
import { motion } from 'framer-motion';
import { X } from "lucide-react";
import { fetchGallery } from '@/store/slices/gallerySlice';

const ResultsGalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const dispatch = useDispatch();
  const { data, fetchLoading, error } = useSelector((state) => state.gallery);

  useEffect(() => {
    dispatch(fetchGallery());
  }, [dispatch]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setSelectedImage(null);
      }
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const galleryItems = data?.data || [];

  return (
    <div>
      <PageHeader
        title="Gallery"
        subtitle="Celebrating our students’ achievements and campus life"
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'Gallery' }
        ]}
      />

      <section className="section-padding">
        <div className="container-custom">

          <SectionTitle
            title="Success Moments"
            description="A glimpse of our proud achievers and vibrant campus"
            className="mb-12"
          />

          {/* ✅ GALLERY GRID */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {galleryItems.map((item, index) => (
              <motion.div
                key={item.id || index}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
              >
                <Card
                  onClick={() => setSelectedImage(item.image)}
                  className="cursor-pointer overflow-hidden rounded-2xl shadow-md hover:shadow-2xl transition"
                >
                  <img
                    src={item.image}
                    alt={item.title || `Gallery ${index + 1}`}
                    className="aspect-[4/5] w-full object-cover hover:scale-110 transition duration-500"
                  />
                </Card>
              </motion.div>
            ))}
          </div>

        </div>
      </section>

      {/* ✅ FULLSCREEN MODAL */}
      {selectedImage && (
        <div
          onClick={() => setSelectedImage(null)}
          className="fixed inset-0 bg-black/95 flex items-center justify-center z-50"
        >

          {/* CROSS BUTTON */}
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-6 right-20 text-white bg-secondary hover:bg-secondary-dark rounded-full p-3 shadow-xl transition"
          >
            <X size={24} strokeWidth={3} />
          </button>

          <div onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage}
              alt="Full View"
              className="max-h-[90vh] max-w-[95vw] object-contain rounded-xl shadow-2xl"
            />
          </div>

        </div>
      )}


    </div>
  );
};

export default ResultsGalleryPage;